module.exports = __webpack_public_path__ + "img/step3_3.1ce844af.jpg";